exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form.checkout {\n    max-width: 500px;\n    margin: 2rem auto;\n    text-align: center;\n    border: 2px solid #eee;\n    border-radius: 8px;\n    padding: 1rem 2rem;\n    background: white;\n  \n    font-family: monospace;\n    color: #525252;\n    font-size: 1.1rem;\n  }\n  \n  form.checkout button {\n    padding: 0.5rem 1rem;\n    color: white;\n    background: coral;\n    border: none;\n    border-radius: 4px;\n    margin-top: 1rem;\n  }\n  \n  form.checkout button:active {\n    background: rgb(165, 76, 43);\n  }\n  .StripeElement {\n    margin: 1rem 0 1rem;\n    background-color: white;\n    padding: 8px 12px;\n    border-radius: 4px;\n    border: 1px solid transparent;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    transition: box-shadow 150ms ease;\n  }\n  \n  .StripeElement--focus {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n  }\n  \n  .StripeElement--invalid {\n    border-color: #fa755a;\n  }\n  \n  .StripeElement--webkit-autofill {\n    background-color: #fefde5 !important;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/tanveer/Documents/sportsYala_New/sportswebmobplatform-18023153-angular4/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main